import e from "../managers/braze-instance.js";
import ee from "./feed-provider.js";
const re = {
  t: !1,
  provider: null,
  er: () => (
    re.o(),
    re.provider || ((re.provider = new ee(e.l(), e.mr())), e.ar(re.provider)),
    re.provider
  ),
  o: () => {
    re.t || (e.u(re), (re.t = !0));
  },
  destroy: () => {
    (re.provider = null), (re.t = !1);
  }
};
export default re;
